import Image from "@/components/Image";
import { BuyVipDialog } from "@/components/Vip";
import formatTime from "@/utils/formatTime";
import { getExpireDateTxt } from "@/utils/gaoding";
import { isBasicTypeByCode, isPersonalTypeByCode } from "@/utils/gaodingVip";
import { useGdVipInfo } from "@/utils/hooks/useGdVipInfo";
import { gaodingEditHost } from "@/utils/host";
import { Button } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { useMemo } from "react";
import { useVipCardRedTip } from "../redTipState";
import styles from "./gaoding.module.less";

export function GdVipCard() {
  const { data } = useGdVipInfo();

  const { couponTip, onCouponClick } = useVipCardRedTip();

  const {
    code,
    icon,
    title,
    gdesignProductMod: gdesignVip,
    isPlus,
    isMaterialVipExpired,
    materialVipVersion,
    materialVip,
    materialExprieDate,
    gdesignExprieDate,
    productExpireDate,
    isGdesignVipExpired,
  } = data || {};

  // 是否是个人组织
  const isPersonalOrg = isPersonalTypeByCode(code);

  const materialVipBottom = useMemo(() => {
    return (
      <div className={styles.vipBottom}>
        <Link href={"/me/download"}>
          <a data-gd-click="button_click" data-button-name="下载记录">
            <div>下载记录</div>
          </a>
        </Link>
        <Link href={"/me/coupon"}>
          <a
            onClick={onCouponClick}
            data-gd-click="button_click"
            data-button-name="优惠券"
          >
            <div>优惠券</div>
            {couponTip && <span className={styles.redTip}></span>}
          </a>
        </Link>
        <Link href={"/me/right"}>
          <a data-gd-click="button_click" data-button-name="会员权益">
            <div>会员权益</div>
          </a>
        </Link>
      </div>
    );
  }, [couponTip, onCouponClick]);

  if (!data) return null;

  return (
    <div className={classNames(styles.vips, styles[code])}>
      <div className={styles.header}>
        <div className={styles.title}>
          <Image src={icon} alt="icon" height={28} />
          <div>
            <div>{title}</div>
            <div className={styles.expire}>
              {productExpireDate ? getExpireDateTxt(productExpireDate) : ""}
            </div>
          </div>
        </div>

        <div>
          <a
            className={styles.damspace}
            target="_blank"
            href={
              `https://${gaodingEditHost}` +
              (isPersonalOrg ? "/team-space-upgrade" : "/dam/teams")
            }
            data-gd-click="button_click"
            data-gd-expose="button_expose"
            data-button-name={isPersonalOrg ? "免费升级为团队" : "团队空间"}
          >
            {isPersonalOrg
              ? `${isBasicTypeByCode(code) ? "" : "免费"}升级为团队`
              : "团队空间"}
          </a>
        </div>
      </div>

      {isPlus ? (
        materialVipBottom
      ) : (
        <>
          <div className={classNames(styles.card)}>
            {materialVip?.length > 0 ? (
              <>
                <div className={styles.container}>
                  <div className={styles.title}>素材下载会员</div>
                  {isMaterialVipExpired ? (
                    <>
                      <div className={styles.desc}>
                        会员已于 {formatTime(materialExprieDate, "YYYY-MM-DD")}{" "}
                        到期
                      </div>
                      <div className={styles.right}>
                        <Button
                          data-gd-click="button_click"
                          data-button-name="续费-素材"
                          onClick={() => {
                            BuyVipDialog.open({
                              source: "个人头像下拉框",
                              source_location: "续费",
                            });
                          }}
                        >
                          续费
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={styles.desc}>
                        授权类型: {materialVipVersion?.authText}
                      </div>
                      <div className={styles.right}>
                        <div className={styles.expire}>
                          {getExpireDateTxt(materialExprieDate)}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {materialVipBottom}
              </>
            ) : (
              <>
                <div className={styles.container}>
                  <div className={styles.title}>购买素材会员</div>
                  <div className={styles.desc}>过亿版权素材·下载商用源文件</div>
                  <div className={styles.right}>
                    <Button
                      data-gd-click="button_click"
                      data-button-name="立即开通-素材"
                      onClick={() => {
                        BuyVipDialog.open({
                          source: "个人头像下拉框",
                          source_location: "立即开通",
                        });
                      }}
                    >
                      立即开通
                    </Button>
                  </div>
                </div>
                {isMaterialVipExpired && materialVipBottom}
              </>
            )}
          </div>
          <div className={classNames(styles.card)}>
            {gdesignVip && !isGdesignVipExpired ? (
              // 有会员
              <div className={styles.container}>
                <div className={styles.title}>模板会员</div>
                <div className={styles.desc}>海量可商用模板·高清无水印下载</div>
                <div className={styles.right}>
                  <div className={styles.expire}>
                    {getExpireDateTxt(gdesignExprieDate)}
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.container}>
                <div className={styles.title}>购买模板会员</div>
                <div className={styles.desc}>海量可商用模板·高清无水印下载</div>
                <div className={styles.right}>
                  <Button
                    data-gd-click="button_click"
                    data-button-name="立即开通-模板"
                    onClick={() =>
                      window.open(`https://${gaodingEditHost}/pricing`)
                    }
                  >
                    立即开通
                  </Button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
